// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0;
  text-align: center;
}
.item ion-button {
  min-width: 0;
  width: 100%;
  --padding-start: 0;
  --padding-end: 0;
  --box-shadow: 0;
}

.flex {
  gap: 2px;
  display: flex;
  flex-direction: column;
}
.flex .flex-row {
  gap: 2px;
}

.ion-card {
  max-width: 1000px;
  margin: 0 auto;
  width: 100%;
  direction: ltr;
}

.card-md {
  background: transparent;
}

.card-content {
  background: transparent;
}

.keys .row .col {
  padding: 5px;
}

.keys .row button {
  display: inline-block;
  width: 100%;
  line-height: 44px;
  font-size: 8rem;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.numberswidth {
  max-width: 500px;
  margin: 0 auto;
}

.keys {
  background-color: transparent;
}

.keys button {
  background-color: white;
  color: black;
}

.keys ion-col {
  margin: 3px;
}

.keys .row button.btnfull {
  width: 100%;
}

.keys .row button.btnEnter {
  width: 100%;
  background-color: #E84028;
  color: white;
}

@media only screen and (max-width: 1050px) {
  .keys .row button {
    display: inline-block;
    width: 100%;
    height: 34px;
    line-height: 44px;
    font-size: 3rem;
    color: white;
    border-radius: 4px;
    padding: 0;
    margin: 3px;
    box-sizing: border-box;
  }
}`, "",{"version":3,"sources":["webpack://./src/core/components/keyboard/keyboard.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;AACF;AAEE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAAJ;;AAIA;EACE,QAAA;EACA,aAAA;EACA,sBAAA;AADF;AAGE;EACE,QAAA;AADJ;;AAKA;EACE,iBAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;AAFF;;AAMA;EACE,uBAAA;AAHF;;AAMA;EACE,uBAAA;AAHF;;AAOA;EACE,YAAA;AAJF;;AAOA;EAEE,qBAAA;EACA,WAAA;EAEA,iBAAA;EACA,eAAA;EAEA,UAAA;EACA,SAAA;EAEA,sBAAA;AAPF;;AAUA;EACE,gBAAA;EACA,cAAA;AAPF;;AAUA;EACE,6BAAA;AAPF;;AAUA;EACE,uBAAA;EACA,YAAA;AAPF;;AAUA;EACE,WAAA;AAPF;;AAWA;EACE,WAAA;AARF;;AAWA;EACE,WAAA;EACA,yBAAA;EACA,YAAA;AARF;;AAWA;EACE;IACE,qBAAA;IACA,WAAA;IACA,YAAA;IACA,iBAAA;IACA,eAAA;IACA,YAAA;IACA,kBAAA;IACA,UAAA;IACA,WAAA;IAEA,sBAAA;EARF;AACF","sourcesContent":[".item {\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: 0;\n  text-align: center;\n\n\n  ion-button{\n    min-width: 0;\n    width: 100%;\n    --padding-start: 0;\n    --padding-end: 0;\n    --box-shadow: 0;\n  }\n}\n\n.flex{\n  gap: 2px;\n  display: flex;\n  flex-direction: column;\n\n  .flex-row{\n    gap: 2px;\n  }\n}\n\n.ion-card {\n  max-width: 1000px;\n  margin: 0 auto;\n  width: 100%;\n  direction: ltr;\n}\n\n\n.card-md {\n  background: transparent;\n}\n\n.card-content {\n  background: transparent;\n\n}\n\n.keys .row .col {\n  padding: 5px;\n}\n\n.keys .row button {\n\n  display: inline-block;\n  width: 100%;\n  //height: 106px;\n  line-height: 44px;\n  font-size: 8rem;\n  //border-radius: 4px;\n  padding: 0;\n  margin: 0;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.numberswidth {\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n.keys {\n  background-color: transparent;\n}\n\n.keys button {\n  background-color: white;\n  color: black;\n}\n\n.keys ion-col {\n  margin: 3px;\n}\n\n\n.keys .row button.btnfull {\n  width: 100%;\n}\n\n.keys .row button.btnEnter {\n  width: 100%;\n  background-color: #E84028;\n  color: white;\n}\n\n@media only screen and (max-width: 1050px) {\n  .keys .row button {\n    display: inline-block;\n    width: 100%;\n    height: 34px;\n    line-height: 44px;\n    font-size: 3rem;\n    color: white;\n    border-radius: 4px;\n    padding: 0;\n    margin: 3px;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
